import { SVGLike } from "../../../../../../public/SVG/SVGLike";
import { SVGDeslike } from "../../../../../../public/SVG/SVGDeslike";
import { SVGRemoveFiltro } from "../../../SVG/SVGRemoveFiltro";
import styles from "./stylesCard.module.css"
import { useEffect } from "react";

export function AdvancedCard({ valorUnitario = '', gradientColor, title = '', value = '', colorText = 'text-slate-500', porcentagem = "", isFiltered = false, showIconFiltered = false, isPrincipal = false, showButtonLike = true, likeMode = true, setLikeMode, setFilter, tMedio, perc }) {
    const renderButtonLike = () => {
        return (
            <div style={{
                opacity: showIconFiltered && likeMode ? 0.4 : 1,
                pointerEvents: showIconFiltered && likeMode ? 'none' : 'auto'
            }} >
                {showButtonLike ?
                    likeMode ?
                        <SVGLike onClick={() => {
                            setLikeMode(false)
                            setFilter(true)
                        }} color='green' style={{ cursor: 'pointer' }} />
                        :
                        <SVGDeslike onClick={() => {
                            setLikeMode(true)
                            setFilter(false)
                        }} color='red' style={{ cursor: 'pointer' }} />
                    :
                    null
                }
            </div>
        )
    }


    useEffect(() => {
        
    }, [])

    return (
        <div
            style={{}}
            className={` ${styles.card} bg-white-100 h-full rounded-xl relative pb-5 shadow-lg flex flex-row
            ${isPrincipal ? 'mt-[-1.25rem] h-[120%]  ' : ''}
            `}
        >
            <div
                onClick={() => {
                    setFilter(value => !value)
                    setLikeMode(true)
                }}
                className={`
                    flex justify-center items-center bg-gradient-to-b ${gradientColor} shadow-lg  
                    ${isFiltered ? 'cursor-pointer transform transition duration-500 hover:scale-110' : ''}
                    ${isPrincipal ? ` ${styles.circleCard} border-white-200 border-[0.3rem] ml-[-1rem] h-[7rem] w-[14rem] rounded-[50%] mt-[-3.5rem]` 
                        : 'rounded-xl h-[4.5rem] w-[17rem] mt-[-1.25rem] ml-2'}
                    
                    `}
                style={{ background: isPrincipal && '#5081da' }}
            >
                <p className={`${styles.value} text-white-200 font-bold ${isPrincipal ? 'text-3xl font-bold' : 'text-2xl'} `}>
                    {value}
                </p>

                {porcentagem ? <p className={`${styles.porcentagem}  mb-1 absolute bottom-0 right-0 mr-3 text-white-200 `}>
                    {parseFloat(porcentagem) > 0 ? porcentagem : '0,00'} %
                </p> : null}

                {showIconFiltered
                    ? <div
                        className="IconRemoveFilter"
                    >
                        <SVGRemoveFiltro color={title === 'Perdidos' ? 'white' : 'red'} />
                    </div>
                    : null
                }
            </div>
            <div className={`mt-3 flex flex-col w-full ml-2 mr-4 `}>
                <div className="flex flex-row items-center justify-between " >
                    <p className={` ${styles.title} text-lg text-slate-500 ${isPrincipal ? 'font-bold text-2xl' : ''}`}>
                        {title}
                    </p>
                    {renderButtonLike()}
                </div>

                <div className={`border border-slate-200 shadow-lg mb-2`}>

                </div>

                <div className={styles.containerValorUnitario} >
                    <p className={styles.valorUnitario} >R$ {valorUnitario || `0,00`}</p>
                    <p className={styles.perc} > ({perc !== 'NaN' ? perc : '0,00'}%)</p>
                </div>

                <div className={styles.containerValorUnitario} >
                    <p className={styles.valorUnitario} >R$ {tMedio || '0,00'}</p>
                    <p className={styles.perc} > (Ticket médio)</p>
                </div>
            </div>
        </div>
    )
}
